import liff from '@line/liff';
import { Box, Button } from '@mui/material';

const RedirectFallBack = () => {
  return (
    <>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <Button
          variant={'contained'}
          color={'primary'}
          sx={{
            fontSize: '1rem',
            padding: '12px 24px',
          }}
          onClick={() => {
            liff.closeWindow();
          }}
        >
          返回 line
        </Button>
      </Box>
    </>
  );
};

export default RedirectFallBack;
